import GamificationModal from './GamificationModal.container';
export default GamificationModal;
